// @flow
import * as React from 'react';
import type { Node } from 'react';

import s from './BreadCrumbs.scss';

type View = {
  name: string,
  displayName: string,
  completed: boolean,
  currentView: boolean,
  altIcon?: Node,
  altButton?: Node,
}

type Props = {
  updateView: (view: string, confirmed: ?boolean) => void,
  views: View[],
}

const BreadCrumbs = (props: Props) => {
  const { views, updateView } = props;
  const crumbFlexBasis = views && 100/views.length;

  return (
    <ul id={s.breadcrumbs}>
      {
        views.map((view, i) => {
          const crumbStyle = determineCrumbStyle(view);
          const button = view.altButton ||
                        <button onClick={() => updateView(view.name)}
                          disabled={!view.completed}
                          className={s.link_name}
                        >
                          { view.displayName }
                        </button>;
          const icon = view.altIcon || <div data-testid='circle-icon' className={s.circle}></div>
          return (
            <li
              key={i}
              className={crumbStyle.join(' ')}
              style={{flexBasis: `${crumbFlexBasis}%`}}
            >
              <div>
                { icon }
                <hr/>
              </div>
              {button}
            </li>
          )
        })
      }
    </ul>
  )
}

function determineCrumbStyle(view: View) {
  let crumbStyle = [s.crumb];
  if (view.currentView) {
    crumbStyle.push(`${s.selected}`);
  }
  if (view.completed) {
    crumbStyle.push(`${s.completed}`);
  }
  return crumbStyle;
}



export default BreadCrumbs;


